import React from "react";
import { useSelector } from "react-redux";
import { useHardCode } from "../../hooks";
export const ReviewExchangeSummary = ({
  itemValue,
  priceDifference,
  reverseShipment,
  dueOrRefund,
  className,
  isReturn = false,
}) => {
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const {
    SHOPIFY_SHOP_OBJECT,
    CURRENT_STORE_NAME,
    PURE_FEMALE_TRANSLATION,
    IMMACULATE_VEGAN,
  } = useHardCode();
  const hideRefundAmount = false;
  const isStorePureFemale =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const SUMMARY = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.summary
    : storeConfigState?.themeConfig?.summary;
  const REFUND_METHOD = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.refund_method
    : storeConfigState?.themeConfig?.refund_method_page_title;
  const REFUND_METHOD_TYPE = isStorePureFemale
    ? refundSettingsState.refundMethod ===
      storeConfigState?.themeConfig?.store_credits
      ? PURE_FEMALE_TRANSLATION.review.store_credits
      : PURE_FEMALE_TRANSLATION.review.original_payment_method
    : refundSettingsState.refundMethod;
  const isStoreImmaculateVegan =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.immaculate_vegan;
  const disclaimer_heading = IMMACULATE_VEGAN.disclaimer.heading;
  const disclaimer_content = IMMACULATE_VEGAN.disclaimer.content;
  const disclaimer_element = (
    <div className="disclaimer_content">
      <p className="review-summary-card-heading">{disclaimer_heading}</p>
      <p>{disclaimer_content}</p>
    </div>
  );

  return (
    <div className={`review-summary-card-content ${className}`}>
      {isReturn ? (
        <>
          <div className="review-summary-card-heading">{SUMMARY}</div>
          <div className="review-summary-refund-method">
            <span className="payment-method-text">
              {`${REFUND_METHOD}:${REFUND_METHOD_TYPE}`}
            </span>
            {refundSettingsState?.paymentAmount && (
              <p className="payment-method-text">
                {storeConfigState?.themeConfig?.reverse_shipment_fee}:
                {productDetailsState.currency}
                {refundSettingsState.paymentAmount}
              </p>
            )}
            {isStoreImmaculateVegan && disclaimer_element}
          </div>
          {hideRefundAmount && (
            <div className="review-summary-total-refund">
              <span className="payment-method-text">
                {
                  storeConfigState?.themeConfig
                    ?.exchange_review_total_refund_label
                }
                :{productDetailsState.currency}
                {refundSettingsState.totalRefund}
              </span>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="review-summary-card-heading">{SUMMARY}</div>
          <div className="review-summary-refund-method">
            {itemValue && (
              <span className="payment-method-text">{itemValue}</span>
            )}
          </div>
          <div className="review-summary-total-refund">
            {priceDifference && (
              <span className="payment-method-text">{priceDifference}</span>
            )}
          </div>
          {reverseShipment > 0 && (
            <div className="review-summary-total-refund">
              <p className="payment-method-text">
                {storeConfigState?.themeConfig?.reverse_shipment_fee} :{" "}
                {productDetailsState.currency}
                {reverseShipment}
              </p>
            </div>
          )}
          <div className="review-summary-total-refund">
            {dueOrRefund && (
              <span className="payment-method-text">{dueOrRefund}</span>
            )}
          </div>
          {isStoreImmaculateVegan && disclaimer_element}
        </>
      )}
    </div>
  );
};
